import { Container } from 'pixi.js'
import { type Orientation, type Resizable } from '../../framework/render/design'
import { SpriteButton } from '../../framework/ui/SpriteButton'
import { bottomBarTexture } from '../assets/BottomBarTextures'
import type { GameBus } from '../events/GameEvents'
import type { PlayerState } from '../state/PlayerState'
import type { ReelsView } from '../view/ReelsView'

// ExtraBet 加注開關 — 沿用 Unity pic_extraBetOn/Off_btn（藍色 EX 圖標 + 紅/紫膠囊 OFF/ON）。
// 對齊真實遊戲畫面：擺在主盤框左下角外側、Bonus 立輪下方（不再放底部操作列右側）。
// 以 ReelsView.frameRect（主盤框螢幕矩形）為定位基準，旋轉進行中由 uiBusy 鎖定。

// 開關高度佔主盤框高度比例（橫/直版各一）；及在框左下角的水平/垂直微調比例。皆為估計值，可微調。
const HEIGHT_RATIO: Readonly<Record<Orientation, number>> = { landscape: 0.12, portrait: 0.07 }
const X_INSET_RATIO = 0.22 // 開關中心相對框左緣往內偏移（佔開關顯示寬），讓開關主要露在框左下外側
const Y_LIFT_RATIO = 0.5 // 開關中心相對框底上抬（佔開關高），約使開關底緣貼齊框底

export class ExtraBetToggle extends Container implements Resizable {
  private readonly button: SpriteButton
  private buttonHeight = 0

  constructor(bus: GameBus, player: PlayerState, private readonly reels: ReelsView) {
    super()
    this.button = new SpriteButton(
      bottomBarTexture('btn_extrabet_off'),
      bottomBarTexture('btn_extrabet_on'),
      () => {
        player.extraBet = !player.extraBet
        this.button.setActive(player.extraBet)
        bus.emit('extraBetChanged', { active: player.extraBet })
        bus.emit('betChanged', { bet: player.bet })
      },
    )
    this.button.setActive(player.extraBet)
    this.addChild(this.button)

    bus.on('uiBusy', ({ busy }) => this.button.setEnabled(!busy))
  }

  resize(_width: number, _height: number, orientation: Orientation): void {
    const rect = this.reels.frameRect
    if (rect.width <= 0 || rect.height <= 0) return

    this.buttonHeight = rect.height * HEIGHT_RATIO[orientation]
    this.button.setHeight(this.buttonHeight)

    const frameLeft = rect.cx - rect.width / 2
    const frameBottom = rect.cy + rect.height / 2
    this.button.position.set(
      frameLeft + this.button.displayWidth * X_INSET_RATIO,
      frameBottom - this.buttonHeight * Y_LIFT_RATIO,
    )
  }
}
